// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-025c0388] {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  width: 100%;\n  height: auto;\n}\n.is-ios[data-v-025c0388] {\n  bottom: 86px;\n}\n.is-app[data-v-025c0388] {\n  bottom: 26px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
